export class Publication {
  abstract: string;
  associated_publications: any[] = [];
  contributors: any[] = [];
  format: string;
  keywords: string;
  nts: any[] = [];
  price: number;
  publ_num: string;
  purpose: string;
  release_date: string;
  rgp_district: any[] = [];
  scale: string;
  series_en: string;
  series_fr: string;
  title: string;
  topics: any[] = [];
  townships: any[] = [];
  type: string;
  updated_at: string;
  updated_section: string;
  year: number;
  go_file: any[] = [];

  constructor(init?: Partial<Publication>) {
    Object.assign(this, init);
  }
}
